// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* table css */

tr.hide-table-padding td {
    padding: 0;
}

.expand-button {
    position: relative;
    cursor: pointer;
    border: none !important;
}

.accordion-toggle .expand-button:after {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translate(0, -50%);
    content: "-";
}

.accordion-toggle.collapsed .expand-button:after {
    content: ">";
}

.QuestionnairesDashboard{
    font-size: 17PX;
}

.vl {
        border-left: 1px solid #d3d3d3;
        height: 35px;
}
.btnClose{
    background-color: #6c2fbb !important;
    color: white; 
}

::ng-deep .cdk-overlay-pane.generate_title{
    position: relative !important;
    bottom: 27%;
}

::ng-deep .cdk-overlay-pane.analytics-modal {
    background: #f8fafb;
    margin-block: 30px !important;
    position: relative  !important;
    height: calc(100vh - 50px)  !important;
}
.bulk-group {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}
.btn-bulk {
    background-color: white;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 12px;
    border-color: #6c2fbb !important;
}
.btn-bulk.btn-delete {
    padding-block: 9px;
    background-color: #dd3939;
    border-color : #dd3939 !important;
}
.btn-bulk.bulk-active-button{
    background-color: #6c2fbb;
}
.btn-bulk.bulk-active-button img{
    filter: brightness(0) invert(1)
}
.bulk-active {
    border: 1px solid #6c2fbb;
    border-radius: 16px;
    box-shadow: 0 0 6px 2px rgba(108, 47, 187, 0.15);
    position: relative;
}
.bulk-active .bulk-check {
    display: flex;
    align-items: center;
    justify-content: center;
}
.bulk-active .bulk-check i {
    font-size: 22px;
    color: #6c2fbb;
    background: white;
    border-radius: 100%;
}

.group-sharing-btn {
  border-radius: 5px;
  border: solid 1px #6c2fbb;
  background-color: #6c2fbb;
  font-size: 12px;
  padding: 8px 30px;
  width: 100%;
  color: white;
}

@media (max-width: 1440px) {
    ::ng-deep .cdk-overlay-pane.analytics-modal {
        width: 88% !important;
    }
}

/* ::ng-deep .cdk-overlay-pane.analytics-modal {
    overflow: auto;
} */

.bg-change1,
.bg-change2,
.bg-change3,
.bg-change4,
.bg-change5,
.bg-change6 {
    background-color: #6c2fbb !important;
    color: white;
}

table {
    border: 2px #cecece solid;
    border-collapse: collapse;
}

table td {
    border-left: 1px solid #80808078;
}

table th {
    border-left: 1px solid #80808078;
}

#anlyticsModal {
    overflow-y: hidden !important;
    max-height: 635px !important;
    padding-bottom: 15px !important;
}

table td:first-child {
    border-left: none;
}

.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    cursor: pointer;
}

.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.reaction-img {
    margin: 0px 5px;
}

.modal-body {
    overflow: scroll;
    height: 462px !important;
    /* max-height: auto; */
    text-align: center;
}


.contributor-list table {
    margin-bottom: 18px;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: none !important;
    /* border: 1px solid #ddd; */
}

.contributor-list td,
.contributor-list th {
    text-align: left;
    padding: 7px;
    font-size: 14px;
    border: none !important;
}

.contributor-list tr:nth-child(even) {
    background-color: #f2f2f2;
}

.member-admin-profile {
    height: 50px;
    width: 50px;
    object-fit: cover;
    /*border-radius: 50%;*/
    border-radius: 10px;
    /*border: 2px solid white !important;*/
}

.contributor-list .profile-image {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    border-radius: 10px;
    /*margin-right: 0;*/
    /*margin-right: 0;*/
}



/*.contributor {*/
/*    width: 30px;*/
/*    height: 30px;*/
/*    object-fit: cover;*/
/*    border-radius: 50%;*/
/*}*/

/*.contributor-list {*/
/*    list-style-type: none;*/
/*    margin: 0;*/
/*    padding: 0;*/
/*}*/

/*.contributor-list li {*/
/*    margin-bottom: 20px;*/
/*}*/



.hove-one {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    opacity: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    z-index: -1;
    align-items: center;
    display: flex;
    background: rgba(0, 0, 0, 0.5);
}

.hove-one a {
    display: inline-block;
    padding: 10px;
    width: 32%;
    color: #fff;
}

.hove-one a svg {
    font-size: 20px;
}

.hove-one a:hover {
    /*color:  #7a2df9;*/
}

.class-hover {
    position: relative;
}

.class-hover:hover .hove-one {
    opacity: 1;
    z-index: 9;
}

.like-cmt-select > select {
    height: 50px;
    font-size: 15px;
}

.fa-ellipsis-v {
    cursor: pointer;
}

.drop-menu {
    transform: translate3d(-118px, 0px, 0px);
    min-width: 7rem;
}

.like-cmt-select > label {
    position: absolute;
    font-size: 15px;
    left: 30px;
    top: 15px;
    color: #878787;
}

.like-cmt-select button span {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #555;
    display: inline-block;
}

.like-cmt-select button {
    position: absolute;
    transform: translateY(-50%);
    right: 16px;
    top: 25px;
    width: 50px;
    background-color: #f5f7f6;
}


.video-container:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
    /*border-radius: 10px;*/
}

.video-container:hover .published-options {
    display: block;
    width: 100%;
}

.published-option-active {
    display: block !important;
}

.video-container:hover .video-like {
    /*display: none;*/
}

.hide-video-like {
    display: none !important;
}

.published-options li {
    padding: 4px 10px;
}

.published-options {
    display: none;
    margin-right: 100px;
    list-style-type: none;
    margin-bottom: 0;
}

.published-options li a:hover {
    color: #6c2fbb;
}


@media (max-width: 1024px) {
    .published-options {
        margin-right: 0px;
    }
}


/************************************************************************/


.my-groups h2 {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;

}

.group-box {
    padding: 20px;
    border-radius: 16px;
    background-color: #ffff;
    position: relative;
    margin: 20px 0;
}


.img-box {
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #f8f9fa;
}

.img-box img {
    object-fit: fill;
}

.next p {
    font-weight: 600;
    text-align: right;
    cursor: pointer;
    margin-top: 50px;
}

.next p a {
    color: #6c2fbb;
}

.next p a:hover {
    text-decoration: none;
}


.draft-con .col-xl-4 {
    margin-top: 30px;
}


.group-box .two-btns {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 5px 10px;

}

.group-box .two-btns button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border: none;
}

.group-box .two-btns button span {
    color: #fff;
    font-size: 17px !important;
}

.my-video-draft p {
    padding: 15px 0 0 0;
    /*margin-top: 5px;*/
    font-size: 14px;
    font-weight: 400;
    color: rgba(136, 133, 142, 1);
}

.my-video-draft h5 {
    padding: 14px 0 0 0;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
}


.my-videos-tab {
    width: 100%;
    /*margin-top: 20px;*/
}

.my-videos-tab ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.my-videos-tab ul li {
    list-style: none;
    /*font-weight: 500;*/
    font-size: 18px;
    padding: 5px 0;
    margin: 0 25px;
    color: #878395;
    cursor: pointer;
}

.my-videos-tab ul li.active {
    border-top: 3px solid rgba(108, 47, 187, 1);
    color: rgba(108, 47, 187, 1);
}

/* .group-box .activity-textbox {
    display: flex;
    height: 100%;
    align-items: flex-start;
    justify-content: space-between;

} */

.draft-saved-date {
    color: #727272;
}

.group-box .activity-textbox p {
    padding: 1px 0;
    margin: 0 8px;
    font-weight: 400;
    font-size: 14px;
    color: #727272;
}

.group-box .activity-textbox .sharedby {
    padding: 1px 0;
    font-weight: 400;
    font-size: 14px;
    color: #727272;
}

.group-box .activity-textbox h4 {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    color: #0f062b;
}

.group-box .activity-textbox .more-images {
    background: #F5F5F5 !important;
    border: 1px solid #727272 !important;
    color: #727272;
}

.categories-btn {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 5px 17px;
    font-size: 14px;
    font-weight: 400;
    background: #FFFFFF;
    border-radius: 12px;
    /*margin: 5px 7px 5px 0px;*/
    margin: 20px 7px 5px 0;
    /*white-space: nowrap;*/
}

.categories-btn-collab-video {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 5px 17px;
    font-size: 14px;
    font-weight: 400;
    background: #FFFFFF;
    border-radius: 12px;
    /*margin: 5px 7px 5px 0px;*/
    margin: 0px 7px 5px 0;
    /*white-space: nowrap;*/
}

.private-badge {
    color: #fff;
    padding: 5px 15px;
    border: 1px solid #fff;
    background: #6c2fbb;
    border-radius: 12px;
    align-self: center;
}

@media (max-width: 1400px) {
    .categories-btn {
        font-size: 14px;
        margin: 20px 5px;
    }
}


.video-like {
    display: flex;
    gap: 10px;
}

.video-like p {
    color: #000000;
}

/*tab two style*/
.img-box-pub {
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    /*height: 213px;*/
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 16px;
    width: 100%;
}

.img-box-pub img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.FF-scroll-modify {
    height: 66vh !important;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 20px;
}
.timeLineTree img{
    width: 25px !important;
    height: 20px !important;
    max-height: 15px;
}

.tab-dropdown {
    position: relative;
}
.tab-dropdown:hover .tab-menu {
    transform: scale(1);
}
.tab-dropdown .tab-arrow {
    transition: all 0.2s;
}
.tab-dropdown:hover .tab-arrow {
    rotate: 180deg;
}
.tab-menu {
    position: absolute;
    min-width: 200px;
    top: 100%;
    left: 12px;
    background-color: white;
    border: 1px solid #e9e9e9;
    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);
    z-index: 1;
    transform: scale(0);
    transition: all 0.2s;
}
.tab-menu::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: white;
    border-top: 1px solid #e9e9e9;
    border-left: 1px solid #e9e9e9;
    rotate: 45deg;
    top: -10px;
    left: 75px;
    z-index: -1;
}
.tab-menu .my-videos-tab {
    padding: 0;
}
.tab-menu .my-videos-tab ul {
    flex-direction: column;
    padding-left: 0;
    align-items: flex-start;
}
.tab-menu .my-videos-tab ul li {
    font-size: 15px;
    margin: 0;
    border-top: none;
    padding: 6px 12px;
    width: 100%;
    white-space: nowrap;
    cursor: pointer;
}
.tab-menu .my-videos-tab ul li:hover {
    color: #5e35b1
}
.tab-menu .my-videos-tab ul li.active {
    background-color: #f1eafe;
}

@media (max-width: 1700px) {
    .img-box {
        height: 255px
    }
}

@media (max-width: 1600px) {
    .img-box {
        height: 192px
    }

    .img-box-pub {
        height: 185px
    }
}

.video-container {
    align-content: center;
    padding: 15px 0;
}

@media (max-width: 1400px) {
    .group-box .activity-textbox h5 {
        margin-bottom: 8px;
        font-size: 20px;
    }

    .group-box .activity-textbox p {
        line-height: 18px;
    }

    .group-box .two-btns {
        position: absolute;
        top: 5px;
        right: 5px;

    }

    .group-box .two-btns button span {
        font-size: 15px !important;
    }

    .img-box {
        height: 192px
    }

}

@media (max-width: 1200px) {
    .group-box .activity-textbox h4 {
        margin-bottom: 10px;
    }
}

@media (max-width: 991px) {
    .group-box .activity-textbox h5 {
        margin-bottom: 5px;
        font-size: 25px;
    }

    .group-box .activity-textbox p {
        line-height: 18px;
    }

    .group-box {
        position: relative;
        margin: 10px 0;
    }

    .draft-con h5 {
        margin-top: 8px;
        font-size: 18px;
    }

}

@media (max-width: 768px) {
    .group-box .activity-textbox h5 {
        margin-bottom: 3px;
        font-size: 18px;
        margin-top: 0;
    }

    .group-box .activity-textbox p {
        line-height: 15px;
        font-size: 15px;
    }

    .group-box {
        position: relative;
        margin: 10px 0;
    }

    .published-con {
        padding: 17px 5px;
    }

    .my-videos-tab ul li {

        font-size: 17px;
    }

    .my-groups h2 {
        font-weight: 700;
        font-size: 24px;
    }

    .my-video-draft p {
        font-size: 15px;
    }

    .next p {
        margin-top: 15px;
    }

    .draft-con .col-xl-4 {
        margin-top: 15px;
    }

    .img-box {
        height: 200px;
    }

    .draft-con h5 {
        font-size: 16px;
    }
}


@media (max-width: 400px) {
    .group-box .activity-textbox {
        flex-direction: column;
    }

    .group-box .activity-textbox {
        align-items: flex-start;
    }


    .video-like {
        margin-top: 8px;
    }
}

.margin-zero p {
    margin: 0 !important;
}

a {
    color: black;
    font-weight: 400;
  }

.refer-box {
    position: relative;
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 16px;
    padding: 10px 20px;
    text-align: center;
}

.prof-sm {
    border-radius: 4px;
    width: 25px;
    height: 25px;
    font-size: 14px;
}

/*group-share list*/
.group-share {
    padding: 0 10px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 3px;
}

.group-share img {
    border-radius: 10px;
    min-width: 50px;
    object-fit: cover;
    margin-right: 10px;
}

.group-share h5 {
    font-size: 14px;
}

/*transfer owner*/
.sharing-links {
    list-style-type: none;
    padding: 0;
    /*text-align: center;*/
    margin-top: 20px;
    margin-bottom: 40px;
    max-height: 360px;
    overflow-y: auto;
}

.sharing-links li {
    display: inline-block;
    padding-right: 20px;
    padding-left: 20px;
    cursor: pointer;
}

.sharing-links .follow-share {
    /*padding: 5px 20px;*/
    position: relative;
    /*margin-bottom: 15px;*/
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 10px;
}

.sharing-links .follow-share.active {
    background-color: #f2f2f2;
}

.sharing-links .follow-share img {
    border-radius: 10px;
    min-width: 50px;
    object-fit: cover;
    margin-right: 10px;
}

.sharing-links .follow-share h5 {
    font-size: 14px;
    margin-bottom: 0;
}

.group-dropdown-btn img {
    filter: brightness(0);
}
.group-dropdown-btn::after {
    display: none;
}
.group-dropdown-btn {
    border: 0;
    background-color: transparent;
}

@media (max-width: 1199px) {
    .video-like {
        flex-wrap: wrap;
    }
    .video-container .published-options {
        padding-left: 0;
    }
}
@media (max-width: 991px) {
    .video-container .published-options {
        display: block;
    }
}
@media (max-width: 767px) {
    .categories-btn {
        margin-bottom: 0;
    }
}
@media only screen and (max-width: 575px) and (min-width: 320px) {
    .categories-btn {
        margin: 4px 0;
    }

    .like-cmt-select > label {
        top: 0;
    }
}
@media (min-width: 992px) {
    .group-dropdown-menu {
        display: block;
        position: unset;
        float: unset;
        min-width: auto;
        padding: 0;
        margin: 0;
        font-size: unset;
        color: inherit;
        text-align: left;
        list-style: none;
        background-color: transparent;
        background-clip: padding-box;
        border: 0;
        border-radius: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/new-my-videos/new-my-videos.component.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;QACQ,8BAA8B;QAC9B,YAAY;AACpB;AACA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI;AACJ;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;;GAEG;;AAEH;;;;;;IAMI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IAEX,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA,iBAAiB;AACjB,mBAAmB;AACnB,oBAAoB;AACpB,yBAAyB;AACzB,0BAA0B;AAC1B,IAAI;;AAEJ,sBAAsB;AACtB,6BAA6B;AAC7B,iBAAiB;AACjB,kBAAkB;AAClB,IAAI;;AAEJ,yBAAyB;AACzB,2BAA2B;AAC3B,IAAI;;;;AAIJ;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ;;;AAGA,yEAAyE;;;AAGzE;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;;;;;;GAMG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;;AAGA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,2CAA2C;IAC3C,UAAU;IACV,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI;AACJ;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;;IAEd;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI;IACJ;;AAEJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;;IAGA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,gBAAgB;EAClB;;AAEF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,MAAM;IACV;AACJ;AACA;IACI;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,eAAe;QACf,UAAU;QACV,SAAS;QACT,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,6BAA6B;QAC7B,4BAA4B;QAC5B,SAAS;QACT,gBAAgB;IACpB;AACJ","sourcesContent":["/* table css */\n\ntr.hide-table-padding td {\n    padding: 0;\n}\n\n.expand-button {\n    position: relative;\n    cursor: pointer;\n    border: none !important;\n}\n\n.accordion-toggle .expand-button:after {\n    position: absolute;\n    left: 0.75rem;\n    top: 50%;\n    transform: translate(0, -50%);\n    content: \"-\";\n}\n\n.accordion-toggle.collapsed .expand-button:after {\n    content: \">\";\n}\n\n.QuestionnairesDashboard{\n    font-size: 17PX;\n}\n\n.vl {\n        border-left: 1px solid #d3d3d3;\n        height: 35px;\n}\n.btnClose{\n    background-color: #6c2fbb !important;\n    color: white; \n}\n\n::ng-deep .cdk-overlay-pane.generate_title{\n    position: relative !important;\n    bottom: 27%;\n}\n\n::ng-deep .cdk-overlay-pane.analytics-modal {\n    background: #f8fafb;\n    margin-block: 30px !important;\n    position: relative  !important;\n    height: calc(100vh - 50px)  !important;\n}\n.bulk-group {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.btn-bulk {\n    background-color: white;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 12px;\n    border-color: #6c2fbb !important;\n}\n.btn-bulk.btn-delete {\n    padding-block: 9px;\n    background-color: #dd3939;\n    border-color : #dd3939 !important;\n}\n.btn-bulk.bulk-active-button{\n    background-color: #6c2fbb;\n}\n.btn-bulk.bulk-active-button img{\n    filter: brightness(0) invert(1)\n}\n.bulk-active {\n    border: 1px solid #6c2fbb;\n    border-radius: 16px;\n    box-shadow: 0 0 6px 2px rgba(108, 47, 187, 0.15);\n    position: relative;\n}\n.bulk-active .bulk-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.bulk-active .bulk-check i {\n    font-size: 22px;\n    color: #6c2fbb;\n    background: white;\n    border-radius: 100%;\n}\n\n.group-sharing-btn {\n  border-radius: 5px;\n  border: solid 1px #6c2fbb;\n  background-color: #6c2fbb;\n  font-size: 12px;\n  padding: 8px 30px;\n  width: 100%;\n  color: white;\n}\n\n@media (max-width: 1440px) {\n    ::ng-deep .cdk-overlay-pane.analytics-modal {\n        width: 88% !important;\n    }\n}\n\n/* ::ng-deep .cdk-overlay-pane.analytics-modal {\n    overflow: auto;\n} */\n\n.bg-change1,\n.bg-change2,\n.bg-change3,\n.bg-change4,\n.bg-change5,\n.bg-change6 {\n    background-color: #6c2fbb !important;\n    color: white;\n}\n\ntable {\n    border: 2px #cecece solid;\n    border-collapse: collapse;\n}\n\ntable td {\n    border-left: 1px solid #80808078;\n}\n\ntable th {\n    border-left: 1px solid #80808078;\n}\n\n#anlyticsModal {\n    overflow-y: hidden !important;\n    max-height: 635px !important;\n    padding-bottom: 15px !important;\n}\n\ntable td:first-child {\n    border-left: none;\n}\n\n.arrow {\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    display: inline-block;\n    padding: 3px;\n    cursor: pointer;\n}\n\n.right {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n}\n\n.reaction-img {\n    margin: 0px 5px;\n}\n\n.modal-body {\n    overflow: scroll;\n    height: 462px !important;\n    /* max-height: auto; */\n    text-align: center;\n}\n\n\n.contributor-list table {\n    margin-bottom: 18px;\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    border: none !important;\n    /* border: 1px solid #ddd; */\n}\n\n.contributor-list td,\n.contributor-list th {\n    text-align: left;\n    padding: 7px;\n    font-size: 14px;\n    border: none !important;\n}\n\n.contributor-list tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n.member-admin-profile {\n    height: 50px;\n    width: 50px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    /*border-radius: 50%;*/\n    border-radius: 10px;\n    /*border: 2px solid white !important;*/\n}\n\n.contributor-list .profile-image {\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    border-radius: 10px;\n    /*margin-right: 0;*/\n    /*margin-right: 0;*/\n}\n\n\n\n/*.contributor {*/\n/*    width: 30px;*/\n/*    height: 30px;*/\n/*    object-fit: cover;*/\n/*    border-radius: 50%;*/\n/*}*/\n\n/*.contributor-list {*/\n/*    list-style-type: none;*/\n/*    margin: 0;*/\n/*    padding: 0;*/\n/*}*/\n\n/*.contributor-list li {*/\n/*    margin-bottom: 20px;*/\n/*}*/\n\n\n\n.hove-one {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    opacity: 0;\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    z-index: -1;\n    align-items: center;\n    display: flex;\n    background: rgba(0, 0, 0, 0.5);\n}\n\n.hove-one a {\n    display: inline-block;\n    padding: 10px;\n    width: 32%;\n    color: #fff;\n}\n\n.hove-one a svg {\n    font-size: 20px;\n}\n\n.hove-one a:hover {\n    /*color:  #7a2df9;*/\n}\n\n.class-hover {\n    position: relative;\n}\n\n.class-hover:hover .hove-one {\n    opacity: 1;\n    z-index: 9;\n}\n\n.like-cmt-select > select {\n    height: 50px;\n    font-size: 15px;\n}\n\n.fa-ellipsis-v {\n    cursor: pointer;\n}\n\n.drop-menu {\n    transform: translate3d(-118px, 0px, 0px);\n    min-width: 7rem;\n}\n\n.like-cmt-select > label {\n    position: absolute;\n    font-size: 15px;\n    left: 30px;\n    top: 15px;\n    color: #878787;\n}\n\n.like-cmt-select button span {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 6px solid #555;\n    display: inline-block;\n}\n\n.like-cmt-select button {\n    position: absolute;\n    transform: translateY(-50%);\n    right: 16px;\n    top: 25px;\n    width: 50px;\n    background-color: #f5f7f6;\n}\n\n\n.video-container:hover {\n    background-color: #f8f9fa;\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);\n    /*border-radius: 10px;*/\n}\n\n.video-container:hover .published-options {\n    display: block;\n    width: 100%;\n}\n\n.published-option-active {\n    display: block !important;\n}\n\n.video-container:hover .video-like {\n    /*display: none;*/\n}\n\n.hide-video-like {\n    display: none !important;\n}\n\n.published-options li {\n    padding: 4px 10px;\n}\n\n.published-options {\n    display: none;\n    margin-right: 100px;\n    list-style-type: none;\n    margin-bottom: 0;\n}\n\n.published-options li a:hover {\n    color: #6c2fbb;\n}\n\n\n@media (max-width: 1024px) {\n    .published-options {\n        margin-right: 0px;\n    }\n}\n\n\n/************************************************************************/\n\n\n.my-groups h2 {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n\n}\n\n.group-box {\n    padding: 20px;\n    border-radius: 16px;\n    background-color: #ffff;\n    position: relative;\n    margin: 20px 0;\n}\n\n\n.img-box {\n    aspect-ratio: 16/9;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    background: #f8f9fa;\n}\n\n.img-box img {\n    object-fit: fill;\n}\n\n.next p {\n    font-weight: 600;\n    text-align: right;\n    cursor: pointer;\n    margin-top: 50px;\n}\n\n.next p a {\n    color: #6c2fbb;\n}\n\n.next p a:hover {\n    text-decoration: none;\n}\n\n\n.draft-con .col-xl-4 {\n    margin-top: 30px;\n}\n\n\n.group-box .two-btns {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    padding: 2px 10px;\n    border-radius: 5px 10px;\n\n}\n\n.group-box .two-btns button {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n    border: none;\n}\n\n.group-box .two-btns button span {\n    color: #fff;\n    font-size: 17px !important;\n}\n\n.my-video-draft p {\n    padding: 15px 0 0 0;\n    /*margin-top: 5px;*/\n    font-size: 14px;\n    font-weight: 400;\n    color: rgba(136, 133, 142, 1);\n}\n\n.my-video-draft h5 {\n    padding: 14px 0 0 0;\n    font-size: 16px;\n    font-weight: 500;\n    color: #000000;\n}\n\n\n.my-videos-tab {\n    width: 100%;\n    /*margin-top: 20px;*/\n}\n\n.my-videos-tab ul {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.my-videos-tab ul li {\n    list-style: none;\n    /*font-weight: 500;*/\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.my-videos-tab ul li.active {\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    color: rgba(108, 47, 187, 1);\n}\n\n/* .group-box .activity-textbox {\n    display: flex;\n    height: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n\n} */\n\n.draft-saved-date {\n    color: #727272;\n}\n\n.group-box .activity-textbox p {\n    padding: 1px 0;\n    margin: 0 8px;\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n}\n\n.group-box .activity-textbox .sharedby {\n    padding: 1px 0;\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n}\n\n.group-box .activity-textbox h4 {\n    margin-bottom: 0;\n    font-size: 16px;\n    font-weight: 400;\n    color: #0f062b;\n}\n\n.group-box .activity-textbox .more-images {\n    background: #F5F5F5 !important;\n    border: 1px solid #727272 !important;\n    color: #727272;\n}\n\n.categories-btn {\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n    padding: 5px 17px;\n    font-size: 14px;\n    font-weight: 400;\n    background: #FFFFFF;\n    border-radius: 12px;\n    /*margin: 5px 7px 5px 0px;*/\n    margin: 20px 7px 5px 0;\n    /*white-space: nowrap;*/\n}\n\n.categories-btn-collab-video {\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n    padding: 5px 17px;\n    font-size: 14px;\n    font-weight: 400;\n    background: #FFFFFF;\n    border-radius: 12px;\n    /*margin: 5px 7px 5px 0px;*/\n    margin: 0px 7px 5px 0;\n    /*white-space: nowrap;*/\n}\n\n.private-badge {\n    color: #fff;\n    padding: 5px 15px;\n    border: 1px solid #fff;\n    background: #6c2fbb;\n    border-radius: 12px;\n    align-self: center;\n}\n\n@media (max-width: 1400px) {\n    .categories-btn {\n        font-size: 14px;\n        margin: 20px 5px;\n    }\n}\n\n\n.video-like {\n    display: flex;\n    gap: 10px;\n}\n\n.video-like p {\n    color: #000000;\n}\n\n/*tab two style*/\n.img-box-pub {\n    aspect-ratio: 16/9;\n    display: flex;\n    justify-content: center;\n    /*height: 213px;*/\n    position: relative;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 16px;\n    width: 100%;\n}\n\n.img-box-pub img {\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n.FF-scroll-modify {\n    height: 66vh !important;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    margin-top: 20px;\n}\n.timeLineTree img{\n    width: 25px !important;\n    height: 20px !important;\n    max-height: 15px;\n}\n\n.tab-dropdown {\n    position: relative;\n}\n.tab-dropdown:hover .tab-menu {\n    transform: scale(1);\n}\n.tab-dropdown .tab-arrow {\n    transition: all 0.2s;\n}\n.tab-dropdown:hover .tab-arrow {\n    rotate: 180deg;\n}\n.tab-menu {\n    position: absolute;\n    min-width: 200px;\n    top: 100%;\n    left: 12px;\n    background-color: white;\n    border: 1px solid #e9e9e9;\n    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.05);\n    z-index: 1;\n    transform: scale(0);\n    transition: all 0.2s;\n}\n.tab-menu::after {\n    content: '';\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background-color: white;\n    border-top: 1px solid #e9e9e9;\n    border-left: 1px solid #e9e9e9;\n    rotate: 45deg;\n    top: -10px;\n    left: 75px;\n    z-index: -1;\n}\n.tab-menu .my-videos-tab {\n    padding: 0;\n}\n.tab-menu .my-videos-tab ul {\n    flex-direction: column;\n    padding-left: 0;\n    align-items: flex-start;\n}\n.tab-menu .my-videos-tab ul li {\n    font-size: 15px;\n    margin: 0;\n    border-top: none;\n    padding: 6px 12px;\n    width: 100%;\n    white-space: nowrap;\n    cursor: pointer;\n}\n.tab-menu .my-videos-tab ul li:hover {\n    color: #5e35b1\n}\n.tab-menu .my-videos-tab ul li.active {\n    background-color: #f1eafe;\n}\n\n@media (max-width: 1700px) {\n    .img-box {\n        height: 255px\n    }\n}\n\n@media (max-width: 1600px) {\n    .img-box {\n        height: 192px\n    }\n\n    .img-box-pub {\n        height: 185px\n    }\n}\n\n.video-container {\n    align-content: center;\n    padding: 15px 0;\n}\n\n@media (max-width: 1400px) {\n    .group-box .activity-textbox h5 {\n        margin-bottom: 8px;\n        font-size: 20px;\n    }\n\n    .group-box .activity-textbox p {\n        line-height: 18px;\n    }\n\n    .group-box .two-btns {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n\n    }\n\n    .group-box .two-btns button span {\n        font-size: 15px !important;\n    }\n\n    .img-box {\n        height: 192px\n    }\n\n}\n\n@media (max-width: 1200px) {\n    .group-box .activity-textbox h4 {\n        margin-bottom: 10px;\n    }\n}\n\n@media (max-width: 991px) {\n    .group-box .activity-textbox h5 {\n        margin-bottom: 5px;\n        font-size: 25px;\n    }\n\n    .group-box .activity-textbox p {\n        line-height: 18px;\n    }\n\n    .group-box {\n        position: relative;\n        margin: 10px 0;\n    }\n\n    .draft-con h5 {\n        margin-top: 8px;\n        font-size: 18px;\n    }\n\n}\n\n@media (max-width: 768px) {\n    .group-box .activity-textbox h5 {\n        margin-bottom: 3px;\n        font-size: 18px;\n        margin-top: 0;\n    }\n\n    .group-box .activity-textbox p {\n        line-height: 15px;\n        font-size: 15px;\n    }\n\n    .group-box {\n        position: relative;\n        margin: 10px 0;\n    }\n\n    .published-con {\n        padding: 17px 5px;\n    }\n\n    .my-videos-tab ul li {\n\n        font-size: 17px;\n    }\n\n    .my-groups h2 {\n        font-weight: 700;\n        font-size: 24px;\n    }\n\n    .my-video-draft p {\n        font-size: 15px;\n    }\n\n    .next p {\n        margin-top: 15px;\n    }\n\n    .draft-con .col-xl-4 {\n        margin-top: 15px;\n    }\n\n    .img-box {\n        height: 200px;\n    }\n\n    .draft-con h5 {\n        font-size: 16px;\n    }\n}\n\n\n@media (max-width: 400px) {\n    .group-box .activity-textbox {\n        flex-direction: column;\n    }\n\n    .group-box .activity-textbox {\n        align-items: flex-start;\n    }\n\n\n    .video-like {\n        margin-top: 8px;\n    }\n}\n\n.margin-zero p {\n    margin: 0 !important;\n}\n\na {\n    color: black;\n    font-weight: 400;\n  }\n\n.refer-box {\n    position: relative;\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 16px;\n    padding: 10px 20px;\n    text-align: center;\n}\n\n.prof-sm {\n    border-radius: 4px;\n    width: 25px;\n    height: 25px;\n    font-size: 14px;\n}\n\n/*group-share list*/\n.group-share {\n    padding: 0 10px;\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    margin-bottom: 3px;\n}\n\n.group-share img {\n    border-radius: 10px;\n    min-width: 50px;\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.group-share h5 {\n    font-size: 14px;\n}\n\n/*transfer owner*/\n.sharing-links {\n    list-style-type: none;\n    padding: 0;\n    /*text-align: center;*/\n    margin-top: 20px;\n    margin-bottom: 40px;\n    max-height: 360px;\n    overflow-y: auto;\n}\n\n.sharing-links li {\n    display: inline-block;\n    padding-right: 20px;\n    padding-left: 20px;\n    cursor: pointer;\n}\n\n.sharing-links .follow-share {\n    /*padding: 5px 20px;*/\n    position: relative;\n    /*margin-bottom: 15px;*/\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n}\n\n.sharing-links .follow-share.active {\n    background-color: #f2f2f2;\n}\n\n.sharing-links .follow-share img {\n    border-radius: 10px;\n    min-width: 50px;\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.sharing-links .follow-share h5 {\n    font-size: 14px;\n    margin-bottom: 0;\n}\n\n.group-dropdown-btn img {\n    filter: brightness(0);\n}\n.group-dropdown-btn::after {\n    display: none;\n}\n.group-dropdown-btn {\n    border: 0;\n    background-color: transparent;\n}\n\n@media (max-width: 1199px) {\n    .video-like {\n        flex-wrap: wrap;\n    }\n    .video-container .published-options {\n        padding-left: 0;\n    }\n}\n@media (max-width: 991px) {\n    .video-container .published-options {\n        display: block;\n    }\n}\n@media (max-width: 767px) {\n    .categories-btn {\n        margin-bottom: 0;\n    }\n}\n@media only screen and (max-width: 575px) and (min-width: 320px) {\n    .categories-btn {\n        margin: 4px 0;\n    }\n\n    .like-cmt-select > label {\n        top: 0;\n    }\n}\n@media (min-width: 992px) {\n    .group-dropdown-menu {\n        display: block;\n        position: unset;\n        float: unset;\n        min-width: auto;\n        padding: 0;\n        margin: 0;\n        font-size: unset;\n        color: inherit;\n        text-align: left;\n        list-style: none;\n        background-color: transparent;\n        background-clip: padding-box;\n        border: 0;\n        border-radius: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
